import { GridFilterOperator } from "@mui/x-data-grid-pro";

import { operator } from "types";

export const getGridBooleanOperators = (
  trueLabel = "is true",
  falseLabel = "is false"
): GridFilterOperator[] => [
  {
    label: trueLabel,
    value: operator.isTrue,
    getApplyFilterFn: () => {
      return (params) => {
        return !!params;
      };
    }
  },
  {
    label: falseLabel,
    value: operator.isFalse,
    getApplyFilterFn: () => {
      return (params) => {
        return !params;
      };
    }
  }
];
